const CHARGIFY_JS_VERSION = '2026-07-10';
const CHARGIFY_JS_SHA = '4a4ca4474cb24ef6bf98af28149290a8d973fa87';

export default {
  // turn on or off the console logs from the app
  debug: false,
  version: CHARGIFY_JS_VERSION,

  recaptcha: {
    siteKey: {
      dev: '6Lch430rAAAAAIaMZJBmzt7lBEFp_RJFBNk7I9Hi',
      prod: '6Lc822srAAAAALL3-163uf2D9-XRBRh1jVRAxiok',
    },
  },

  server: {
    // path where static assets are located
    // jsHost: 'https://js.maxio.com/v/' + MAXIO_JS_VERSION,

    // path for the HTML of each iframe (i.e. '/path/to/html')
    iframePath: '/hosted-field.html',

    // path for the HTML to main iframe
    mainIframePath: '/main-iframe.html',

    // path for the API to the get token (i.e. '/path/to/token')
    tokenPath: '/js/tokens.json',

    // path for fetching Plaid Link Token
    plaidLinkTokenPath: '/js/plaid_link_tokens',

    // path for fetching Plaid Link Token Verification
    plaidLinkTokenVerificationPath: '/js/plaid_link_tokens/prepare_verification',

    // path for veryfing Plaid Account
    plaidVerifyAccountPath: '/js/tokens/verify_account',
  },

  // these numbers will be valid for credit card number (string)
  creditCardTestNumbers: ['1', '2', '3'],

  Honeybadger: {
    apiKey: 'hbp_4Tni1pwHt8A3ksR6FXZjWIYOWpgK972VSSSS',
    revision: CHARGIFY_JS_VERSION,
    enableUncaught: false,
    enableUnhandledRejection: false,
    projectRoot: 'webpack:///./src/',
  },
};
